const UNCACHED = {};

export const memoOne = <TArg, TReturn>(fn: (arg: TArg) => TReturn) => {
  let cachedArg: unknown = UNCACHED;
  let cachedReturn: TReturn;

  return (arg: TArg) => {
    if (arg !== cachedArg) {
      cachedArg = arg;
      cachedReturn = fn(arg);
    }

    return cachedReturn;
  };
};
